import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DirectionsdTooltip, TooltipOnTop } from "../../../../Constant";
import { DIRECTIONS_TOOLTIP_DATA, DIRECTIONS_TOOLTIP_LIST } from "../../../../Data/UiKit/Tooltip";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonTooltip from "../Common/CommonTooltip";

const TooltipDirections = () => {
  const [tooltip, setTooltip] = useState(false);
  const toggle = () => setTooltip(!tooltip);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DirectionsdTooltip} span={DIRECTIONS_TOOLTIP_DATA} />
        <CardBody>
          <div className="common-flex">
            <Btn color="primary" id="Tooltip-8" className="mb-0 me-0">{TooltipOnTop}</Btn>
            <ToolTip placement="top" isOpen={tooltip} target="Tooltip-8" toggle={toggle}>Tooltip on top</ToolTip>
            {DIRECTIONS_TOOLTIP_LIST.map((item) => (
              <CommonTooltip key={item.id} item={item} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TooltipDirections;
